import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { MainHome, Loading } from './components/molecules/sections';
import { useRestaurantData } from './hooks/useRestaurantData';
import { Header } from "./components/molecules/sections/Header";
import { trackDemoEvent } from "./utils/demoTracker";
import './styles/globals.scss';
import { useEffect } from "react";
import { useRestaurantSlug } from "./hooks/useRestaurantSlug";
import { useUIStore } from "./store";

const ErrorDisplay = ({ message }: { message: string }) => (
  <div className="containerGral" style={{ padding: 24, textAlign: 'center' }}>
    <h2 style={{ marginBottom: 8 }}>Menú no disponible</h2>
    <p style={{ marginBottom: 16 }}>{message}</p>
    <button className="btn-retry" onClick={() => window.location.reload()}>
      Reintentar
    </button>
  </div>
);

const AppLayout = () => {
  const { loading, config, error } = useRestaurantData();
  const setProductOverride = useUIStore((s) => s.setProductOverride);
  const setDemoConfig = useUIStore((s) => s.setDemoConfig);
  const location = useLocation();
  const slug = useRestaurantSlug();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("product");
    const name = params.get("name");
    const price = params.get("price");
    const description = params.get("description");
    const phone = params.get("phone");
    const logo = params.get("logo");
    const color = params.get("color");

    if (id && price) {
      trackDemoEvent("demo_opened", slug, {
        product_id: id,
        metadata: { name, price, color, phone }
      });

      setProductOverride({
        id,
        name: name ? decodeURIComponent(name) : "",
        price: parseFloat(price),
        description: description ? decodeURIComponent(description) : undefined,
      });

      setDemoConfig(phone, logo, color);
    } else {
      trackDemoEvent("menu_viewed", slug);
    }
  }, []);

  if (loading) return <Loading />;
  if (error) return <ErrorDisplay message={error} />;
  if (!config) return <Loading />;

  return (
    <div className="containerGral">
      <Header restaurantName={config.title} />
      <MainHome />
    </div>
  );
};

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorDisplay message="Algo salió mal en el sistema." />}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout />} />
          <Route path="/delivery" element={<AppLayout />} />
          <Route path="/mesa/:nroMesa" element={<AppLayout />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;